import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { CampaignFormPageMessages } from "@/messages/campaigns/campaign-form-page.messages";

import { ExecutionLogsTable } from "./components/Table";

type Props = {
  messages: CampaignFormPageMessages;
};

function StatisticsTab({ messages }: Props) {
  return (
    <MDBox mt={2}>
      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid size={12}>
            <MDBox height="100%">
              <ExecutionLogsTable messages={messages} />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default StatisticsTab;
